module.exports = __webpack_public_path__ + "img/zh_cn.f6604818.png";